import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useAnalyticsAttributes } from './contexts/PopupPickerContext';

export const ANALYTICS_TAGS = ['townsquare'];
export const ANALYTICS_CHANNEL = 'atlas';

type ErrorDetails = {
	message: string;
	stack?: string;
};

export type AnalyticsAttributes = Record<
	string,
	string | number | boolean | ErrorDetails | undefined | object
>;

type FireAnalyticEventProps = {
	eventType: 'track' | 'ui' | 'operational';
	action: string;
	actionSubject: string;
	actionSubjectId?: string;
	analyticsAttributes?: AnalyticsAttributes;
};

export const useFireAnalyticEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const baseAnalyticsAttributes = useAnalyticsAttributes();

	const fireAnalyticsEvent = useCallback(
		({
			analyticsAttributes,
			eventType,
			action,
			actionSubject,
			actionSubjectId,
		}: FireAnalyticEventProps) => {
			const analyticsEvent = createAnalyticsEvent({
				action,
				actionSubject,
				actionSubjectId,
				eventType,
				tags: ANALYTICS_TAGS,
				attributes: { ...analyticsAttributes, ...baseAnalyticsAttributes },
			});
			analyticsEvent.fire(ANALYTICS_CHANNEL);
		},
		[baseAnalyticsAttributes, createAnalyticsEvent],
	);

	return {
		fireAnalyticsEvent,
	};
};
